import React, { Component, Fragment } from "react";
import { Form } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import AlertNoPermission from "../../alerts/AlertNoPermission";

class ShopCategories extends Component {
    state = { shopCategories: [], noPermission: false };

    getEvents = async () => {
        const { fetchURL, onShowAlert, t } = this.props;
        try {
            const response = await fetch(`${fetchURL}/shop-categories`, {
                credentials: "include",
                method: "POST",
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true });
                    else if (fetchedData.status === "notLogged") this.props.onShowHomePage();
                    else if (fetchedData.status === false) onShowAlert({ variant: "danger", message: t(`error.${fetchedData.code}`) });
                    else this.setState({ shopCategories: fetchedData.shopCategories });
                });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: `${t("error.cannotFetchData")} (${err})` });
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        this.getEvents();
    }

    render() {
        const { shopCategories, noPermission } = this.state;
        const { defaultValue, onShopCategoriesSelected, t } = this.props;

        return (
            <Fragment>
                <Form.Label>
                    {t("shop.shopCategory")} <span className="required">*</span>
                </Form.Label>
                {noPermission ? (
                    <AlertNoPermission t={t} />
                ) : (
                    <Dropdown
                        defaultValue={defaultValue}
                        id="shopCategoriesDropdown"
                        className="req mb-3"
                        placeholder={t("shop.clickToChooseCat")}
                        fluid
                        selection
                        options={shopCategories}
                        onChange={(event, { value }) => {
                            onShopCategoriesSelected(event, value);
                        }}
                    />
                )}
            </Fragment>
        );
    }
}

export default ShopCategories;
